"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _styling = require("../toolkit/styling");

var icons = _interopRequireWildcard(require("../toolkit/icons"));

var _providers = require("../toolkit/providers");

var _class, _class2, _class3, _temp, _class4, _class5, _class6, _temp2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ConversationItem = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ConversationItem, _Component);

  var _super = _createSuper(ConversationItem);

  function ConversationItem() {
    var _this;

    (0, _classCallCheck2["default"])(this, ConversationItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(ConversationItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.left)
      }, this.leftIcon, this.verticalLine), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.right)
      }, children));
    }
  }, {
    key: "styles",
    get: function get() {
      var isLast = this.props.isLast;
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          corePrimary = _this$context$theming2.corePrimary,
          textLight = _this$context$theming2.textLight,
          surfaceLight = _this$context$theming2.surfaceLight,
          borderPrimaryDark = _this$context$theming2.borderPrimaryDark,
          borderPrimaryLight = _this$context$theming2.borderPrimaryLight,
          fonts = _this$context$theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          alignItems: "stretch",
          flexDirection: "row",
          justifyContent: "flex-start",
          overflow: "hidden"
        },
        left: {
          width: "48px",
          minHeight: "48px",
          marginRight: "16px",
          display: "flex",
          flexDirection: "column"
        },
        icon: {
          borderRadius: "50%",
          width: "48px",
          height: "48px",
          lineHeight: "48px",
          textAlign: "center",
          fontFamily: fonts.semibold
        },
        verticalLineContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          flex: 1
        },
        verticalLine: {
          width: "1px",
          height: "100%",
          borderLeft: "4px ".concat(borderPrimaryLight, " solid")
        },
        wish: {
          backgroundColor: corePrimary,
          backgroundImage: "url(".concat(icons.wishW, ")"),
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center"
        },
        merch: {
          backgroundColor: surfaceLight,
          color: textLight
        },
        font16: {
          fontSize: "16px"
        },
        font22: {
          fontSize: "22px"
        },
        right: {
          flex: 1,
          marginBottom: !isLast ? "28px" : undefined,
          borderBottom: !isLast ? "1px ".concat(borderPrimaryDark, " solid") : undefined
        }
      });
    }
  }, {
    key: "leftIcon",
    get: function get() {
      var _this$props2 = this.props,
          isWish = _this$props2.isWish,
          locale = _this$props2.locale;
      var styles = this.styles;

      if (isWish) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _styling.css)(styles.icon, styles.wish)
        });
      } else if (locale == "zh") {
        var text = "商户";
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _styling.css)(styles.icon, styles.merch, styles.font16)
        }, text);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(styles.icon, styles.merch, styles.font22)
      }, "M");
    }
  }, {
    key: "verticalLine",
    get: function get() {
      var isLast = this.props.isLast;

      if (isLast) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.verticalLineContainer)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.verticalLine)
      }));
    }
  }]);
  return ConversationItem;
}(_react.Component), _class3.contextType = _providers.LegoContext, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "leftIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leftIcon"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "verticalLine", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "verticalLine"), _class2.prototype)), _class2)) || _class;

var Conversation = (0, _mobxReact.observer)(_class4 = (_class5 = (_temp2 = _class6 = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(Conversation, _Component2);

  var _super2 = _createSuper(Conversation);

  function Conversation() {
    (0, _classCallCheck2["default"])(this, Conversation);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(Conversation, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          style = _this$props3.style;

      var filteredChildren = _react["default"].Children.toArray(children).filter(function (child) {
        return /*#__PURE__*/_react["default"].isValidElement(child);
      });

      var numItems = _react["default"].Children.count(filteredChildren);

      var rootCSS = (0, _styling.css)(this.styles.root, style, className);

      var finalChildren = _react["default"].Children.map(filteredChildren, function (child, index) {
        if (! /*#__PURE__*/_react["default"].isValidElement(child)) {
          return;
        }

        return /*#__PURE__*/_react["default"].cloneElement(child, {
          isLast: index == numItems - 1
        });
      });

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: rootCSS
      }, finalChildren);
    }
  }, {
    key: "styles",
    get: function get() {
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          overflow: "hidden",
          padding: "28px 24px",
          alignItems: "stretch"
        }
      });
    }
  }]);
  return Conversation;
}(_react.Component), _class6.demoRender = "\n<Conversation>\n\n  <Conversation.Item isWish={true} locale=\"en\">\n    <Accordion\n      header=\"Request from Wish\"\n      isOpen={true}\n      hideLines={true}\n      backgroundColor=\"#ffffff\"\n    >\n      <div style={{ padding: \"20px 15px\" }}>Some request</div>\n    </Accordion>\n  </Conversation.Item>\n\n  <Conversation.Item locale=\"en\">\n    <Accordion\n      header=\"Response from merchant\"\n      isOpen={true}\n      hideLines={true}\n      backgroundColor=\"#ffffff\"\n    >\n      <div style={{ padding: \"20px 15px\" }}>Some response</div>\n    </Accordion>\n  </Conversation.Item>\n\n  <Conversation.Item isWish={true} locale=\"en\">\n    <Accordion\n      header=\"Request from Wish\"\n      isOpen={true}\n      hideLines={true}\n      backgroundColor=\"#ffffff\"\n    >\n      <div style={{ padding: \"20px 15px\" }}>Some request</div>\n    </Accordion>\n  </Conversation.Item>\n\n  <Conversation.Item locale=\"en\">\n    <Accordion\n      header=\"Response from merchant\"\n      isOpen={true}\n      hideLines={true}\n      backgroundColor=\"#ffffff\"\n    >\n      <div style={{ padding: \"20px 15px\" }}>Some response</div>\n    </Accordion>\n  </Conversation.Item>\n\n</Conversation>\n  ", _class6.discussion = "Conversation between Wish Support and merchant", _class6.Item = ConversationItem, _temp2), ((0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "styles"), _class5.prototype)), _class5)) || _class4;

var _default = Conversation;
exports["default"] = _default;